"use strict";

exports.__esModule = true;
exports.snapPointToLocation = snapPointToLocation;
function findClosest(array, x) {
  return array.reduce(function (prev, curr) {
    return Math.abs(curr - x) < Math.abs(prev - x) ? curr : prev;
  });
}

/**
 * Given an array of points in time in millis and a target point in time, use the snapToMillis to find the next closest point to snap to and return the millis
 */
function snapPointToLocation(targetMillis, timePointsInMillis, snapToMillis) {
  var closestStep = targetMillis;
  if (snapToMillis) {
    // snapped to nearest millis value
    var rounded = new Date(Math.round(targetMillis / snapToMillis) * snapToMillis);
    closestStep = rounded.valueOf();
  }
  if (timePointsInMillis && timePointsInMillis.length > 0) {
    // first check the snap points

    var closestPoint = findClosest(timePointsInMillis, targetMillis);
    var closestPointDistance = Math.abs(targetMillis - closestPoint);
    var closestStepDistance = Math.abs(targetMillis - closestStep);

    // return the closest point
    return closestPointDistance > closestStepDistance ? closestStep : closestPoint;
  }

  // just return the closest step
  return closestStep;
}